import { render } from "./TextHeadlineSecondary.vue?vue&type=template&id=53f02c48&scoped=true"
const script = {}

import "./TextHeadlineSecondary.vue?vue&type=style&index=0&id=53f02c48&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f02c48"]])

export default __exports__